import SEO_URL_QUERY_KEYS from "@/core/constants/_seo_url_query_keys";

async function parseExtraContentParams(searchParams) {
    const extraContent = {};

    const videos = !!_.get(searchParams, 'videos', false);
    if (videos) {
        extraContent.videos = videos;
    }

    const privateGallery = !!_.get(searchParams, SEO_URL_QUERY_KEYS.GALLERY, false);
    if (privateGallery) {
        extraContent.privateGallery = privateGallery;
    }

    const fskContent = !!_.get(searchParams, 'fskContent', false);
    if (fskContent) {
        extraContent.fskContent = fskContent;
    }

    const sexChat = !!_.get(searchParams, 'sexChat', false);
    if (sexChat) {
        extraContent.sexChat = sexChat;
    }

    const extraContentFromURLPath = this.extractExtraContentFromURLPath();
    this.store.commit('setExtraContent', _.assign({}, extraContent, extraContentFromURLPath));
}

async function generateExtraContentParams(path) {
    let extraContent = this.extraContent;

    const extraContentFromURLPath = this.extractExtraContentFromURLPath(path);

    if (extraContentFromURLPath) {
        extraContent = _.omit(extraContent, Object.keys(extraContentFromURLPath));
    }

    return extraContent;
}

function extractExtraContentFromURLPath(path = window.location.pathname || '') {
    let foundExtraContent = null;

    let splittedUrl = _.compact(path.split('/'));
    if (splittedUrl[0] !== 'sex') {
        const paths = [
            {url: SEO_URL_QUERY_KEYS.GALLERY, privateGallery: true},
        ];

        foundExtraContent = _.find(paths, (path) => splittedUrl.join('/').search(path.url) !== -1);
    }

    return foundExtraContent;
}

const data = () => ({
    store: $store,
});

export default {
    data,
    methods: {
        parseExtraContentParams,
        generateExtraContentParams,
        extractExtraContentFromURLPath,
    },
    computed: {
        ...mapState([
            'extraContent',
        ])
    },
}
